import { Map } from 'immutable';

import { REQUEST_CANCEL_MESSAGE } from './../../constants';
import { START_TYPING_TEST_NAME, ALL_TESTS_LOADED } from './types';
import { GET_TEST_NAMES, GET_TEST_METRICS, GET_TESTS } from './../test-history/types';

const initialState = Map({
  loadingScatterplot: true,
  loadingTests: true,
  fadeMetrics: true,
  isTestSearchLoading: false,
});

const testHistoryViewsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case START_TYPING_TEST_NAME:
      return state.set('isTestSearchLoading', true);
    case GET_TEST_NAMES.SUCCESS:
      return state.set('isTestSearchLoading', false);
    case GET_TEST_NAMES.FAILURE:
      return state.set('isTestSearchLoading', false);
    case GET_TEST_METRICS.REQUEST:
      return state.set('loadingScatterplot', true).set('fadeMetrics', false);
    case GET_TEST_METRICS.SUCCESS:
      return state.set('fadeMetrics', true);
    case GET_TESTS.REQUEST:
      return state.set('loadingTests', true);
    case GET_TESTS.SUCCESS:
      return state.set('loadingTests', false);
    case GET_TESTS.FAILURE:
      if (payload?.message === REQUEST_CANCEL_MESSAGE) {
        return state;
      }
      return state.set('loadingTests', false);
    case ALL_TESTS_LOADED:
      return state.set('loadingScatterplot', false);
    default:
      return state;
  }
};

export default testHistoryViewsReducer;
export { initialState };
